const state = () => ({
    teamStatics: false, // 团队统计界面
})
const getters = {}
const mutations = {
    setTeamStatics(state,value){
        state.teamStatics = value
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
}
